import { createFileRoute } from "@tanstack/react-router"
import { BackofficeOrganizations } from "modules/backoffice/components/organizations"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { BackofficeOrganizationsFilterBySchema, BackofficeOrganizationsSortSchema } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchBackofficeOrganizationsSchema = PaginationSearchSchema.merge(SearchQuerySchema)
  .merge(BackofficeOrganizationsSortSchema.shape.sortBy.unwrap())
  .merge(BackofficeOrganizationsFilterBySchema)

export const Route = createFileRoute("/_base/_auth/backoffice/organizations/list")({
  component: BackofficeOrganizations,
  validateSearch: (search: Partial<z.infer<typeof SearchBackofficeOrganizationsSchema>>) => {
    search.filterBy = search.filterBy || {
      type: ["Client", "Partner"],
    }

    return SearchBackofficeOrganizationsSchema.parse(search)
  },
})
